export default "../../src/img/lysiq-menu-bg.jpg";